import { Component, Input } from '@angular/core';

@Component({
  selector: 'bs-cad-icon',
  imports: [],
  template: `
  <svg id="cad-data-icon" [style.width.px]="width" [style.height.px]="height" [style.fill]="iconFill" [style.stroke]="iconFill" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
    <path d="M7.459,23.679v24.643c0,2.572,1.372,4.949,3.6,6.235l21.341,12.321c2.228,1.286,4.972,1.286,7.2,0l21.341-12.321c2.228-1.286,3.6-3.663,3.6-6.235v-24.643c0-2.572-1.372-4.949-3.6-6.235l-21.341-12.321c-2.228-1.286-4.972-1.286-7.2,0l-21.341,12.321c-2.228,1.286-3.6,3.663-3.6,6.235Z" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="36" y1="36" x2="36" y2="67.843" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="36" y1="36" x2="63.577" y2="20.079" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="36" y1="36" x2="8.423" y2="20.079" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
  </svg>
  `,
  styles: `
    .icon-fill {
        fill: var(--p-bs-icon-color);
  }`,
  standalone: true
})
export class BsCadIconComponent {
  @Input() width: number = 30;
  @Input() height: number = 30;
  @Input() iconFill: string = 'var(--p-bs-icon-color)';
}
